import { zodicCurOther, compare, parity, oddsKeyArray, oddsColorArray, oddsZodiacArray } from '../oddsKeyArray'

// 全車
const initWholeCarKey = () => {
  const mainKey = 'wholeCar'
  let arr = []
  let data = {}

  arr = Array.from({ length: 40 }, (v, i) => {
    if (i) return `${i}:MATCH:NL`
    else return ''
  }).filter(it => it)

  data = arr.reduce((root, oddsKey) => {
    root[oddsKey] = {
      mainKey,
      supKey: 'ball_1to5', //  第1至5球
      groupKey: oddsKey
    }
    return root
  }, {})

  return data
}

// 正碼 的子玩法：第一球、第二球、第三球、第四球、第五球、
const initPositiveCode = () => {
  let data = {}

  for (let i = 1; i < 6; i++) {
    const arr = []
    let supKey = ''
    if (i === 1) supKey = 'firstBall'
    else if (i === 2) supKey = 'secondBall'
    else if (i === 3) supKey = 'thirdBall'
    else if (i === 4) supKey = 'fourthBall'
    else supKey = 'fifthBall'

    // 1:LOCATE:1 系列
    arr.push(...Array.from({ length: 40 }, (v, x) => {
      if (x) return `${x}:LOCATE:${i}`
      else return ''
    }).filter(it => it))

    // 1:OVER 系列
    oddsKeyArray.forEach(it => {
      arr.push(`${i}:${it}`)
    })

    // 1:TAIL:OVER 系列
    compare.forEach(it => {
      arr.push(`${i}:TAIL:${it}`)
    })
    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'positiveCode',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 球色 的子玩法：第一球、第二球、第三球、第四球、第五球、
const initBallColor = () => {
  let data = {}

  for (let i = 1; i < 6; i++) {
    const arr = []
    let supKey = ''
    if (i === 1) supKey = 'firstBall'
    else if (i === 2) supKey = 'secondBall'
    else if (i === 3) supKey = 'thirdBall'
    else if (i === 4) supKey = 'fourthBall'
    else supKey = 'fifthBall'

    // 1:BLUE 系列
    oddsColorArray.forEach(it => arr.push(`${i}:${it}`))

    // 1:BLUE:UNDER 系列
    oddsColorArray.forEach(it => compare.forEach(cit => arr.push(`${i}:${it}:${cit}`)))

    // 1:BLUE:ODD 系列
    oddsColorArray.forEach(it => parity.forEach(cit => arr.push(`${i}:${it}:${cit}`)))

    // 1:BLUE:OVER:ODD 系列
    oddsColorArray.forEach(it => compare.forEach(cit => parity.forEach(pit => arr.push(`${i}:${it}:${cit}:${pit}`))))

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'ballColor',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 尾數連 的子玩法： 一尾連中  一尾連不中
const initOneTailKey = () => {
  const arr = []
  let data = {}

  const fn = (oddsKey) => {
    if (oddsKey.includes('EXCLUDE')) return 'sp_no_one_tail' // 一尾不中
    else return 'one_tail_comb' // 一尾連中
  }

  // 一尾連中 ALL:TAIL:0 系列
  Array.from({ length: 10 }, (v, x) => arr.push(`ALL:TAIL:${x}`))
  // 一尾連不中 ALL:TAIL:0:EXCLUDE 系列
  Array.from({ length: 10 }, (v, i) => arr.push(`ALL:TAIL:${i}:EXCLUDE`))

  data = arr.reduce((root, oddsKey) => {
    root[oddsKey] = {
      mainKey: 'tail_comb',
      supKey: fn(oddsKey),
      groupKey: oddsKey
    }
    return root
  }, {})

  return data
}

// 尾數連 的子玩法：二尾連中、三尾連中、四尾連中、
const initTailKey = () => {
  let data = {}

  for (let i = 1; i < 6; i++) {
    const arr = []
    let supKey = ''
    if (i === 2) supKey = 'sp_two_tail'
    else if (i === 3) supKey = 'sp_three_tail'
    else if (i === 4) supKey = 'sp_four_tail'

    // ALL:TAIL:CHOOSE:2:MATCH:2:0 系列
    arr.push(...Array.from({ length: 10 }, (v, x) => `ALL:TAIL:CHOOSE:${i}:MATCH:${i}:${x}`))
    arr.push(`ALL:TAIL:CHOOSE:${i}:MATCH:${i}`)

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'tail_comb',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 尾數連 的子玩法：二尾連不中、三尾連不中、四尾連不中
const initNoTailKey = () => {
  let data = {}

  for (let i = 2; i < 5; i++) {
    const arr = []
    let supKey = ''
    if (i === 2) supKey = 'sp_no_two_tail'
    else if (i === 3) supKey = 'sp_no_three_tail'
    else supKey = 'sp_no_four_tail'

    // ALL:TAIL:CHOOSE:2:MATCH:0:0 系列
    arr.push(...Array.from({ length: 10 }, (v, x) => `ALL:TAIL:CHOOSE:${i}:MATCH:0:${x}`))
    arr.push(`ALL:TAIL:CHOOSE:${i}:MATCH:0:`)

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'tail_comb',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 五碼位數 的子玩法：五碼位數
const initFiveDigitKey = () => {
  const mainKey = 'five_digit'
  const arr = []
  let data = {}

  oddsKeyArray.forEach(it => {
    arr.push(...Array.from({ length: 6 }, (v, i) => `CHOOSE:${it}:${i}`))
  })

  data = arr.reduce((root, oddsKey) => {
    root[oddsKey] = {
      mainKey,
      supKey: 'five_digit', // 五碼位數
      groupKey: oddsKey
    }
    return root
  }, {})
  return data
}

// 多選中一 的子玩法：(五選中一/六選中一/七選中一/八選中一/九選中一/十選中一)
const initMoreChoiceKey = () => {
  let data = {}

  for (let i = 5; i < 11; i++) {
    const arr = []
    let supKey = ''
    if (i === 5) supKey = 'chose_51'// 五選中一
    else if (i === 6) supKey = 'chose_61'// 六選中一
    else if (i === 7) supKey = 'chose_71'// 七選中一
    else if (i === 8) supKey = 'chose_81'// 八選中一
    else if (i === 9) supKey = 'chose_91'// 九選中一
    else supKey = 'chose_101'// 十選中一

    // CHOOSE:5:MATCH:1 系列
    arr.push(`CHOOSE:${i}:MATCH:1`)

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'doxuan_zhongi',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 多選不中 的子玩法：(五選不中/六選不中/七選不中/八選不中/九選不中/十選不中)
const initMoreChoiceNoWinKey = (locate, status) => {
  let data = {}

  for (let i = 5; i < 11; i++) {
    const arr = []
    let supKey = ''
    if (i === 5) supKey = 'chose_50'// 五選不中
    else if (i === 6) supKey = 'chose_60'// 六選不中
    else if (i === 7) supKey = 'chose_70'// 七選不中
    else if (i === 8) supKey = 'chose_80'// 八選不中
    else if (i === 9) supKey = 'chose_90'// 九選不中
    else supKey = 'chose_100'// 十選不中

    // CHOOSE:5:MATCH:0 系列
    arr.push(`CHOOSE:${i}:MATCH:0`)

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'doxuan_bozhong',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 234星
const initStarKey = () => {
  // mainKey就是【玩法】
  const mainKey = 'star'
  return {
    'CHOOSE:2:MATCH:2:NL': {
      mainKey,
      supKey: 'star',
      groupKey: 'CHOOSE:2:MATCH:2:NL'
    },
    'CHOOSE:3:MATCH:3:NL': {
      mainKey,
      supKey: 'star',
      groupKey: 'CHOOSE:3:MATCH:3:NL'
    },
    'CHOOSE:4:MATCH:4:NL': {
      mainKey,
      supKey: 'star',
      groupKey: 'CHOOSE:4:MATCH:4:NL'
    },
    'MIX:CHOOSE:3:MATCH:2:NL': {
      mainKey,
      supKey: 'uprights_fast', // 三中二
      groupKey: 'MIX:CHOOSE:3:MATCH:2:NL'
    },
    'MIX:CHOOSE:3:MATCH:NL': {
      mainKey,
      supKey: 'uprights_fast', // 三中二
      groupKey: 'MIX:CHOOSE:3:MATCH:NL'
    },
    'MIX:CHOOSE:3:MATCH:3:NL': {
      mainKey,
      supKey: 'set_three_get_three', // 三中三
      groupKey: 'MIX:CHOOSE:3:MATCH:3:NL'
    }
  }
}

// 總和雙面
const initSumTwoSideKey = () => {
  const mainKey = 'total_two_side'
  const arr = []
  let data = {}

  // ALL:SUM:OVER 系列
  oddsKeyArray.forEach(cit => {
    arr.push(`ALL:SUM:${cit}`)
  })

  data = arr.reduce((root, oddsKey) => {
    root[oddsKey] = {
      mainKey,
      supKey: '',
      groupKey: oddsKey
    }
    return root
  }, {})

  return data
}

// 生肖 的子玩法：第一球、第二球、第三球、第四球、第五球、
const initZodicOneKey = () => {
  let data = {}

  for (let i = 1; i < 6; i++) {
    const arr = []
    let supKey = ''

    if (i === 1) supKey = 'ball_1'
    else if (i === 2) supKey = 'ball_2'
    else if (i === 3) supKey = 'ball_3'
    else if (i === 4) supKey = 'ball_4'
    else if (i === 5) supKey = 'ball_5'

    // 1:ZODIAC:CUR 系列
    zodicCurOther.map(it => arr.push(`${i}:ZODIAC:${it}`))

    // 1:ZODIAC:RAT 系列
    oddsZodiacArray.map(it => arr.push(`${i}:ZODIAC:${it}`))

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'zodiac',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 生肖  第1至5球
const initAllZodicKey = (locate) => {
  const mainKey = 'zodiac'
  const arr = []
  let data = {}

  zodicCurOther.map(it => arr.push(`${locate}:ZODIAC:${it}`))
  oddsZodiacArray.map(it => arr.push(`${locate}:ZODIAC:${it}`))

  data = arr.reduce((root, oddsKey) => {
    root[oddsKey] = {
      mainKey,
      supKey: 'ball_1to5',
      groupKey: oddsKey
    }
    return root
  }, {})

  return data
}

// 生肖(連中/不中) 的子玩法：二肖連中、三肖連中、四肖連中
const initZodicComb = () => {
  let data = {}

  for (let i = 2; i < 5; i++) {
    const arr = []
    let supKey = ''
    if (i === 2) supKey = 'zodic_comb_two'
    else if (i === 3) supKey = 'zodic_comb_three'
    else if (i === 4) supKey = 'zodic_comb_four'

    // ALL:ZODIAC:CHOOSE:2:MATCH:2 系列
    zodicCurOther.map(it => arr.push(`ALL:ZODIAC:CHOOSE:${i}:MATCH:${i}:${it}`))
    oddsZodiacArray.map(it => arr.push(`ALL:ZODIAC:CHOOSE:${i}:MATCH:${i}:${it}`))

    arr.push(`ALL:ZODIAC:CHOOSE:${i}:MATCH:${i}`)
    arr.push(`ALL:ZODIAC:CHOOSE:${i}:MATCH:${i}`)

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'zodicComb',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 生肖(連中/不中) 的子玩法：二肖連不中、三肖連不中、四肖連不中
const initZodicCombKey = () => {
  let data = {}

  for (let i = 2; i < 5; i++) {
    const arr = []
    let supKey = ''
    if (i === 2) supKey = 'zodic_comb_two_lose'
    else if (i === 3) supKey = 'zodic_comb_three_lose'
    else if (i === 4) supKey = 'zodic_comb_four_lose'

    zodicCurOther.map(it => arr.push(`ALL:ZODIAC:CHOOSE:${i}:MATCH:0:${it}`))
    oddsZodiacArray.map(it => arr.push(`ALL:ZODIAC:CHOOSE:${i}:MATCH:0:${it}`))

    arr.push(`ALL:ZODIAC:CHOOSE:${i}:MATCH:0`)

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'zodicComb',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 過關 的子玩法：第一球、第二球、第三球、第四球、第五球、
const initPassKey = () => {
  let data = {}

  for (let i = 1; i < 6; i++) {
    const arr = []
    let supKey = ''
    if (i === 1) supKey = 'firstBall'
    else if (i === 2) supKey = 'secondBall'
    else if (i === 3) supKey = 'thirdBall'
    else if (i === 4) supKey = 'fourthBall'
    else if (i === 5) supKey = 'fifthBall'

    oddsKeyArray.forEach(it => arr.push(`${i}:PASS:${it}`))
    oddsColorArray.forEach(it => arr.push(`${i}:PASS:${it}`))

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'pass',
          supKey,
          groupKey: oddsKey
        }
        return root
      }, {})
    }
  }
  return data
}

// 過關 的子玩法：(串兩關/串三關/串四關/串五關)
const initPassLevelKey = () => {
  let data = {}

  for (let i = 2; i < 8; i++) {
    const arr = []
    let supKey = ''
    if (i === 2) supKey = 'pass_two_level' // 串兩關
    else if (i === 3) supKey = 'pass_three_level' // 串三關
    else if (i === 4) supKey = 'pass_four_level' // 串四關
    else if (i === 5) supKey = 'pass_five_level' // 串五關

    arr.push(`ALL:PASS:${i}`)

    data = {
      ...data,
      ...arr.reduce((root, oddsKey) => {
        root[oddsKey] = {
          mainKey: 'pass',
          supKey,
          groupKey: '-'
        }
        return root
      }, {})
    }
  }
  return data
}

export default {
  ...initWholeCarKey(),
  ...initPositiveCode(),
  ...initBallColor(),
  ...initOneTailKey(),
  ...initTailKey(),
  ...initNoTailKey(),
  ...initFiveDigitKey(),
  ...initMoreChoiceKey(),
  ...initMoreChoiceNoWinKey(),
  ...initStarKey(),
  ...initSumTwoSideKey(),
  ...initZodicOneKey(),
  ...initAllZodicKey('NL'),
  ...initZodicComb(),
  ...initZodicCombKey(),
  ...initPassKey(),
  ...initPassLevelKey()
}
